
/**
 * @export
 * @enum {string}
 */
export enum RelationLevel {
    PARENT = 'PARENT',
    CHILD = 'CHILD'
}